import * as actiontypes from "../ActionTypes";

const initialState = {
  loading: false,
  coverImages: [],
  error: null,
};

export default function programCoverImageReducer(state = initialState, action) {
  switch (action.type) {
    case actiontypes.SAVE_PROGRAM_COVERIMAGE_REQUEST:
    case actiontypes.UPDATE_PROGRAM_COVERIMAGE_REQUEST:
      case actiontypes.DELETE_PROGRAM_COVERIMAGE_REQUEST:

      return { ...state, loading: true, error: null };

    case actiontypes.SAVE_PROGRAM_COVERIMAGE_SUCCESS:
    case actiontypes.UPDATE_PROGRAM_COVERIMAGE_SUCCESS: {
      const updated = action.payload;
      const programObjId = updated?.programimageObjId;
      const exists = state.coverImages.some((img) => img.programimageObjId === programObjId);

      return {
        ...state,
        loading: false,
        coverImages: exists
          ? state.coverImages.map((img) =>
              img.programimageObjId === programObjId ? { ...img, ...updated } : img
            )
          : [...state.coverImages, updated],
      };
    }
    case actiontypes.DELETE_PROGRAM_COVERIMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coverImages: state.coverImages.filter(
          (img) =>
            !(
              img.programObjId === action.payload.programObjId &&
              img.programcoverimageObjId === action.payload.programcoverimageObjId
            )
        ),
      };
    case actiontypes.SAVE_PROGRAM_COVERIMAGE_FAILURE:
    case actiontypes.UPDATE_PROGRAM_COVERIMAGE_FAILURE:
      case actiontypes.DELETE_PROGRAM_COVERIMAGE_FAILURE:

      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
